import { CommonModule } from '@angular/common';
import { Inject, ModuleWithProviders, NgModule, Optional } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AuthGuard } from './guards/auth.guard';
import { sessionInterceptorProvider } from './http-interceptors/session.interceptor';
import { defaultGaSessionConfig, GaSessionConfig, GA_SESSION_CONFIG } from './models/SessionConfig';
import { GaSessionConfigService } from './services/session.config.service';
import { GaSessionDataService } from './services/session.data.service';
import { GaSessionService } from './services/session.service';
import { SessionEffects } from './store/session.effects';
import { sessionReducer } from './store/session.store';

@NgModule({
  imports: [
    // Angular and vendors
    CommonModule,
    StoreModule.forFeature('auth', sessionReducer),
    EffectsModule.forFeature([SessionEffects]),
  ],
})
export class GaSessionModule {
  static forRoot(config?: GaSessionConfig): ModuleWithProviders<GaSessionModule> {
    return {
      ngModule: GaSessionModule,
      providers: [
        {
          provide: GA_SESSION_CONFIG,
          useValue: defaultGaSessionConfig,
          multi: true
        },
        {
          provide: GA_SESSION_CONFIG,
          useValue: config,
          multi: true
        },
        AuthGuard,
        GaSessionService,
        GaSessionConfigService,
        GaSessionDataService,
        sessionInterceptorProvider
      ]
    };
  }

  constructor(configService: GaSessionConfigService, @Optional() @Inject(GA_SESSION_CONFIG) configs: GaSessionConfig[] = []) {
    if (!configs) {
      return;
    }
    configs.forEach(c => configService.addConfig(c));
  }
}
